import { useField } from 'formik';

import { Text } from '../../../cdl/Text/Text';
import { FormikFormattedNumberInput } from '../../FormattedNumberInput/FormikFormattedNumberInput';
import { formatNumber } from '../../helpers/formatNumber.helper';
import { Characters } from '../../helpers/unicode.helper';
import { ItemModel, PackType, Unit } from '../../models/ItemModel';

interface UnitsDisplayProps {
    name: string;
    editable: boolean;
    itemDeleted: boolean;
    index: number;
}

export const UnitsDisplay = (props: UnitsDisplayProps) => {
    const [field, meta] = useField(`${props.name}.units`);
    const [itemField] = useField<ItemModel>(props.name);
    const allowDecimals =
        itemField.value.packType === PackType.BULK && [Unit.L, Unit.KG].includes(itemField.value.unit);

    if (props.editable === false) {
        const units = field.value
            ? formatNumber({
                  number: field.value,
              })
            : Characters.EN_DASH;

        return <Text variant="small">{units}</Text>;
    }

    return (
        <FormikFormattedNumberInput
            name={`${props.name}.units`}
            negative={meta.touched && !!meta.error}
            disabled={props.itemDeleted}
            allowDecimals={allowDecimals}
            decimalsLimit={3}
            formatValueOnBlur={false}
            allowNegativeValue={false}
        />
    );
};
